<template>
  <v-card height="100%">
    <v-card-title primary-title>
      <div class="headline">{{labels.coverclause}}</div>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.cover}}</v-subheader>
            <div>{{cargoForm.cover}} - {{query.crgoCover}}</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-title>
      <div class="body-2">{{labels.clause}}</div>
    </v-card-title>
    <v-card-text v-if="clausesList.length > 0">
      <v-container fluid grid-list-lg>
        <v-layout row wrap v-for="(clause, i) in clausesList" :key="i">
          <v-flex xs4>
            <v-subheader class="queryLabel">{{clause.value}}</v-subheader>
          </v-flex>
          <template>
            <v-flex xs7>
              <v-subheader class="queryLabel">{{clause.label}}</v-subheader>
            </v-flex>
            <v-flex xs1>
              <v-tooltip top>
                <v-btn flat icon color="primary" slot="activator" @click="viewClauseText(clause)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <span>View Clause Text</span>
              </v-tooltip>
            </v-flex>
          </template>
        </v-layout>
      </v-container>
      <v-dialog v-model="showClauseText" width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ selectedClause }} - Clause Text </span>
            <v-spacer></v-spacer>
            <v-btn flat icon @click="showClauseText = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-flex xs12>
              <v-textarea v-model="selectedClauseText" readonly auto-grow></v-textarea>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card-text>
    <v-card-text v-else>
      No Clause Found
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      labels: {
        coverclause: 'Coverage/Clauses',
        cover: 'Coverage',
        clause: 'Clause'
      },
      showClauseText: false,
      selectedClause: '',
      selectedClauseText: ''
    }
  },
  computed: {
    cargoForm() {
      return this.$store.state.agency.quotation.cargoForm
    },
    query() {
      return this.$store.state.agency.quotation.queryInfo
    },
    clausesList() {
      return this.query.clauses
    }
  },
  methods: {
    viewClauseText(clause) {
      this.showClauseText = true
      this.selectedClause = clause.value
      this.selectedClauseText = clause.secondaryValue
    }
  }
}
</script>

<style lang="scss">

</style>
